import React from 'react';

import { StatusEntity } from 'types/lead-management';

interface LeadStatusTagProps {
  status?: StatusEntity;
  className?: string;
}

const LeadStatusTag: React.FC<LeadStatusTagProps> = ({
  status,
  className = ''
}) => {
  const { color = '#f4f4f4', value } = status || {};
  return (
    <div
      className={`text-14 flex items-stretch gap-1.5 font-normal text-gray-700 ${className}`}
    >
      <div className="flex h-full items-start">
        <div
          className="mt-2 size-[8px] flex-none rounded-full"
          style={{
            backgroundColor: color
          }}
        />
      </div>
      <div
        className="flex-1 truncate"
        style={{ color, maxWidth: '157px' }}
        title={value}
      >
        {value}
      </div>
    </div>
  );
};

export default LeadStatusTag;
